import { render, staticRenderFns } from "./RenderOverlay.vue?vue&type=template&id=1410a606&scoped=true"
import script from "./RenderOverlay.vue?vue&type=script&lang=js"
export * from "./RenderOverlay.vue?vue&type=script&lang=js"
import style0 from "./RenderOverlay.vue?vue&type=style&index=0&id=1410a606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1410a606",
  null
  
)

export default component.exports